import apiClient from "./axiosConfig";

export const getTemplateConditionLines = async () =>
    apiClient.templatesAPI.get(`/api/v1/template-condition-lines`);

export const createTemplateConditionLine = async (request) =>
    apiClient.templatesAPI.post(`/api/v1/template-condition-lines`, request);

export const updateTemplateConditionLines = async (request) =>
    apiClient.templatesAPI.put(`/api/v1/template-condition-lines`, request);

export const getTemplateConditionLinesOptions = async () =>
    apiClient.templatesAPI.get(`/api/v1/template-condition-lines/options`);

export const getTemplateConditionLinesReports = async (request) =>
    apiClient.templatesAPI.post(`/api/v1/template-condition-lines/report`, request);